import { render, staticRenderFns } from "./AppointmentListItem.vue?vue&type=template&id=550ba24e&scoped=true"
import script from "./AppointmentListItem.vue?vue&type=script&lang=js"
export * from "./AppointmentListItem.vue?vue&type=script&lang=js"
import style0 from "./AppointmentListItem.vue?vue&type=style&index=0&id=550ba24e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550ba24e",
  null
  
)

export default component.exports